module.exports = __webpack_public_path__ + "static/media/emoticon-emoticons-emotion-expression-ninja-face-svgrepo-com.2426e982.svg";